import { useEffect, useState } from 'react'
import { Select, Tag } from 'antd'
import { getAttributeKeyLabel, getAttributeKeys, getNodeLabel, getProjectData, getUid } from 'Services/WeaverUtils'
import { getMemberKey } from 'Services/WeaverUtils'
import ColorService from 'Services/ColorService'
import Feather from '@sysunite/react-feather'
import { matchSorter } from 'match-sorter'

NodePicker = ({ initialData = [], onSelect, placeholder, mode, query, isGreedy = false, suffix, sorter, ...rest }) ->

  suffix ?= () -> ''
  sorter ?= (list) -> list

  [searchIsPrestine, setSearchIsPrestine] = useState(true)
  [searchData, setSearchData] = useState(initialData)
  [isFetching, setIsFetching] = useState(false)
  realKey = getAttributeKeys()[0] or 'name'
  attributeKey = getAttributeKeyLabel(realKey) or 'name'

  useEffect( ->
    ( ->
      if isGreedy then searchNodes('', 5000)
    )()
    undefined
  , [])

  searchNodes = (value, limit = 50) ->
    setIsFetching(true)
    query ?= new Weaver.Query()
    query.limit(limit)

    result = _.unionBy(
      await _.cloneDeep(query)
        .contains('*', value)
        .find(),
      await _.cloneDeep(query)
        .contains('id', value)
        .find()
    , (node) -> getUid(node))

    setSearchData(matchSorter(result, value, {
      keys: [(node) -> getNodeLabel(node)]
      threshold: matchSorter.rankings.NO_MATCH
    }))
    setIsFetching(false)

  useEffect(->
    (->
      searchNodes('')
    )()
    undefined
  , [])

  renderDotIfType = (node) ->
    if typeRel = node.relationsIn[getMemberKey()]
      typeId = typeRel.first().id()
      color = ColorService.getColorForType(typeId)
      <Feather width="1em" height="1em" type="circle" style={{ fill: color, color }} />
    else
      ''

  <Select
    data-testid="node-picker"
    mode={mode}
    placeholder={placeholder or "Targets"}
    filterOption={false}
    defaultActiveFirstOption={true}
    loading={isFetching}
    onSearch={_.debounce(searchNodes, 300, { leading: false, trailing: true })}
    onFocus={ ->
      if searchData.length is 0 or searchIsPrestine
        searchNodes('')
        setSearchIsPrestine(false)
    }
    onChange={onSelect}
    {...rest}
  >
    {
      sorter(searchData).map((item) ->
        <Select.Option
          key={getUid(item)}
          value={getUid(item)}
        >
          <span data-testid={getUid(item)}>
            { renderDotIfType(item) } { getNodeLabel(item, suffix) }
            {if graph = getUid(item)?.split('@')[1]
              <Tag style={{ marginLeft: 5 }}>{ graph }</Tag>
            }
          </span>
        </Select.Option>
      )
    }
  </Select>

export default NodePicker
